<template>
    <div class="wrapper success_base">
        <img src="../../assets/image/taiyuan.jpg" style="width: 100%;height: auto">
    </div>
</template>

<script>

    import _wx from "@/common/_wx";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import cache_url from "@/cache/cache_url";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _copyUrl from "@/common/_copyUrl";
    import lib_clue from "@/libs/lib_clue";

    export default {
        name: "success_base",

        data() {
            return {
                tid: 1, // 5是非汽车行业
            }
        },

        created() {
            document.title = '山西省物产集团首届购车节暨员工内购会';

        },
        methods: {

        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/secondary/base.less";
    @import "../../assets/style/autoshow/form.less";
    // form
    @import "../../assets/style/common/successful.less"; // 成功
    /deep/ .el-divider--horizontal {
        margin: 10px 0;
    }
.success_base{

    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    background: #cb1c39;
}
</style>
